export const getSubUsersGroup = (subusers) => {
  if(!subusers.length) return []
  return subusers.reduce((acc, cur) => {
    const userId = cur.user?.id
    if(!userId) return;
    const currentUserObj = { ...cur.user }
    const currentCountChangeNote = {...cur}
    delete currentCountChangeNote.user

    if(!acc[userId]) {
      acc[userId] = {
        user: currentUserObj,
        changesList: [currentCountChangeNote],
        totalReadyCount: currentCountChangeNote.readyCount
      }
    } else {
      acc[userId].changesList.push(currentCountChangeNote)
      acc[userId].totalReadyCount += currentCountChangeNote.readyCount
    }
    return acc
  }, {})
}